export function isDealerB2BEligible(userData = {}) {
  const companyInformation = userData?.companyInformation || {};
  return (
    companyInformation.verified === true &&
    companyInformation.status === "approved" &&
    companyInformation.accessGranted === true
  );
}

// accessRemoved is a buying restriction, not a seller suspension.
export const canDealerSell = (userData = {}) =>
  isDealerB2BEligible(userData);

export const canDealerBuy = (userData = {}) =>
  isDealerB2BEligible(userData) && userData?.accessRemoved !== true;
